import "./App.css";
import { useEffect, useState } from "react";


// components
import Nav from "./components/nav.jsx";
import { CelestialRhythms } from "./components/times.jsx";
import NextPrayerCountdown from "./components/next prayer countdown.jsx";
import PostPrayerAdhkar from "./components/PostPrayerAdhkar.jsx";
import SalatAyat from "./components/SalatAyat.jsx";
import Footer from "./components/Footer.jsx";
import { useTranslation } from "react-i18next";

function App() {
  const { t, i18n } = useTranslation();
  const [currentLanguage,setCurrnetLanguage]= useState("en")

  function handleLanguageChange(){
    if(currentLanguage==="ar"){
      i18n.changeLanguage("en")
      setCurrnetLanguage("en")
    }
    else{
      i18n.changeLanguage("ar")
      setCurrnetLanguage("ar")

    }
  }
  useEffect(() => {
    i18n.changeLanguage(currentLanguage==="ar"?"ar":"en");
  }, [currentLanguage]);
  return (
    <>
      <title>Sajdah Serenity</title>
      <Nav></Nav>
      <div
        className="container"
        dir={currentLanguage === "ar" ? "rtl" : "ltr"}
      
      >
        <NextPrayerCountdown></NextPrayerCountdown>
        <PostPrayerAdhkar></PostPrayerAdhkar>
        <CelestialRhythms></CelestialRhythms>
        <SalatAyat></SalatAyat>
      </div>
      <Footer
        handleLanguageChange={handleLanguageChange}
        currentLanguage={currentLanguage}
      ></Footer>
    </>
  );
}

export default App;
